import { z } from 'zod';

export const FEEDBACK_RATINGS = ['thumbs_up', 'thumbs_down'] as const;
export type FeedbackRating = (typeof FEEDBACK_RATINGS)[number];

/**
 * Catalog of structured reasons the user can attach to a feedback submission.
 * Open-ended: the frontend may send any string; canonical names are an
 * autocomplete + documentation aid, not enforced by the schema.
 */
export const FEEDBACK_REASONS = [
  'blurry',
  'wrong_color',
  'off_brand',
  'wrong_subject',
  'inaccurate_text',
  'great_match',
  'use_again',
] as const;
export type FeedbackCanonicalReason = (typeof FEEDBACK_REASONS)[number];
export type FeedbackReason = FeedbackCanonicalReason | (string & {});

const COMMENT_MAX = 1000;
const REASON_MAX_CHARS = 64;
const REASONS_MAX_COUNT = 8;

/**
 * Wire shape posted to `POST /api/feedback`. Idempotent by `generationId`:
 * subsequent submissions for the same generation overwrite the prior doc.
 */
export const FeedbackSubmissionSchema = z
  .object({
    generationId: z.string().min(1).max(200),
    rating: z.enum(FEEDBACK_RATINGS),
    comment: z.string().max(COMMENT_MAX).optional(),
    reasons: z.array(z.string().min(1).max(REASON_MAX_CHARS)).max(REASONS_MAX_COUNT).optional(),
  })
  .strict();
export type FeedbackSubmission = z.infer<typeof FeedbackSubmissionSchema>;
